import { ref, computed } from '@vue/composition-api';

class ReactiveMap extends Map {
    onMutate;
    constructor(onMutate, entries) {
        super(entries);
        this.onMutate = onMutate;
    }
    set(key, value) {
        super.set(key, value);
        if (this.onMutate !== undefined) {
            this.onMutate();
        }
        return this;
    }
    delete(key) {
        const res = super.delete(key);
        this.onMutate();
        return res;
    }
    clear() {
        super.clear();
        this.onMutate();
    }
}

function useReactiveMap(entires) {
    function onMutate() {
        map.value = map.value;
    }
    const inner = ref(new ReactiveMap(onMutate, entires));
    const map = computed({
        get: () => {
            return inner.value;
        },
        set: (map) => {
            inner.value = new ReactiveMap(onMutate, map);
        },
    });
    return map;
}

class ReactiveSet extends Set {
    onMutate;
    constructor(onMutate, values) {
        super(values);
        this.onMutate = onMutate;
    }
    add(value) {
        super.add(value);
        if (this.onMutate !== undefined) {
            this.onMutate();
        }
        return this;
    }
    delete(value) {
        const res = super.delete(value);
        this.onMutate();
        return res;
    }
    clear() {
        super.clear();
        this.onMutate();
    }
}

function useReactiveSet(values) {
    function onMutate() {
        set.value = set.value;
    }
    const inner = ref(new ReactiveSet(onMutate, values));
    const set = computed({
        get: () => {
            return inner.value;
        },
        set: (set) => {
            inner.value = new ReactiveSet(onMutate, set);
        },
    });
    return set;
}

export { useReactiveMap, useReactiveSet };
